import { render, staticRenderFns } from "./AlarmDetails.vue?vue&type=template&id=7965ee43&scoped=true&"
import script from "./AlarmDetails.vue?vue&type=script&lang=ts&"
export * from "./AlarmDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmDetails.vue?vue&type=style&index=0&id=7965ee43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965ee43",
  null
  
)

component.options.__file = "AlarmDetails.vue"
export default component.exports